import React from "react";
import "./dashboard.css";
import { Controller, useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router";
import { Input, Button, List } from "antd-mobile";
import message from "antd/es/message";
import Modal from "antd/es/modal";
import Layout from "./Layout";
import { useIntl } from "react-intl";
import * as Sentry from "@sentry/react";
import axios from "axios";

const { REACT_APP_API_URL: API_URL } = process.env;

export default function ResetPassword() {
  const { resetUUID } = useParams();
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const intl = useIntl();

  async function onReset({ password }) {
    Sentry.logger.debug("Password change attempt", { resetUUID });

    await axios(
      {
        method: "post",
        url: `${API_URL}/accounts/change-password`,
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": "true",
        },
        data: { resetUUID, password },
      },
      []
    )
      .then(() => {
        Sentry.logger.info("Password changed successfully", { resetUUID });
        Modal.success({
          content: intl.formatMessage({ id: "password-changed" }),
          okText: intl.formatMessage({ id: "close" }),
          onOk: () => navigate("/login"),
        });
      })
      .catch((error) => {
        if (error.response && error.response.status) {
          if (error.response.status === 400) {
            Sentry.logger.warn("Password change failed - weak password", {
              resetUUID,
            });
            message.error(intl.formatMessage({ id: "too-weak-password" }));
          } else {
            Sentry.captureException(error, {
              contexts: {
                custom: { message: "Password change failed", resetUUID },
              },
            });
            Sentry.logger.error("Password change failed", {
              resetUUID,
              status: error.response.status,
            });
            message.error(intl.formatMessage({ id: "generic-error" }));
          }
        }
      });
  }

  return (
    <Layout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "white",
          margin: 10,
          padding: 10,
          borderRadius: 10,
          marginTop: 50,
        }}
      >
        <div>
          <form onSubmit={handleSubmit(onReset)}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Controller
                name="password"
                control={control}
                defaultValue=""
                rules={{
                  required: true,
                  minLength: 8,
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    onChange={(val) => field.onChange(val)}
                    type="password"
                    style={{
                      background: "white",
                      margin: 10,
                      padding: 10,
                      border: "1px solid #eeeeee",
                      borderRadius: 10,
                    }}
                    placeholder={intl.formatMessage({
                      id: "password-placeholder",
                    })}
                  />
                )}
              />
              {errors.password &&
                errors.password.type === "required" &&
                intl.formatMessage({ id: "password-required" })}
              {errors.password &&
                errors.password.type === "minLength" &&
                intl.formatMessage({ id: "password-length" })}
              <Button type="submit">
                {intl.formatMessage({ id: "password-reset" })}
              </Button>
              <div
                style={{
                  background: "white",
                  margin: 10,
                  padding: 10,
                  borderRadius: 10,
                }}
              >
                <List>
                  <List.Item style={{ fontSize: 12 }}>
                    {intl.formatMessage({ id: "password-length" })}
                  </List.Item>
                  <List.Item style={{ fontSize: 12 }}>
                    {intl.formatMessage({ id: "password-digits" })}
                  </List.Item>
                  <List.Item style={{ fontSize: 12 }}>
                    {intl.formatMessage({ id: "password-similar" })}
                  </List.Item>
                  <List.Item style={{ fontSize: 12 }}>
                    {intl.formatMessage({ id: "password-popular" })}
                  </List.Item>
                </List>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
}
